// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/book.js';

import { paths } from '../generated/book';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('book', Original, paths);
